import { LoginLayout } from '../../../layouts/Login/LoginLayout';
import { PasswordResetForm } from '../PasswordResetForm/PasswordResetForm';
import logoImage from '../../../assets/images/logo-dark.png';
import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

export const FirstTimeSetupPage = () => {
  const [token, setToken] = useState<string>('');
  const [userId, setUserId] = useState<string>('');
  const [searchParams] = useSearchParams();
  useEffect(() => {
    setToken(searchParams.get('token') as string);
    setUserId(searchParams.get('userId') as string);
  }, [searchParams]);
  return (
    <LoginLayout>
      <div className="loginFormContainer">
        <div className="logoContainer">
          <img src={logoImage} alt="" />
        </div>
        {token && userId && (
          <PasswordResetForm
            token={token}
            userId={userId}
            successMessage="Your password has been successfully set."
            confirmPasswordResetEndpoint="/auth/confirm-first-time-email"
          />
        )}
      </div>
    </LoginLayout>
  );
};
